import { combineReducers } from "redux";
import facilities from "../features/admin/room_management/facilities/slice";
import rooms from "../features/admin/room_management/room/slice";
import childcategory from "../features/admin/productmanagement/childcategory/Slice";
import needsSlice from "../features/admin/productmanagement/needs/needsSlice";
import product from "../features/admin/productmanagement/product/Slice";
import offerProduct from "../features/admin/productmanagement/offerproduct/Slice";

const roomsManage = combineReducers({
    facilities: facilities,
    rooms: rooms,

});

export default roomsManage;
